import { render, staticRenderFns } from "./WaypointRead.vue?vue&type=template&id=5a774cd2&scoped=true"
import script from "./WaypointRead.vue?vue&type=script&lang=js"
export * from "./WaypointRead.vue?vue&type=script&lang=js"
import style0 from "./WaypointRead.vue?vue&type=style&index=0&id=5a774cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a774cd2",
  null
  
)

export default component.exports